import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { paymentModeAction } from "../../../../store/paymentModes/action";
export var useGetPaymentMode = function (trigger, projectId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responsePaymentMode: state.PaymentMode.responsePaymentMode,
        loadingPaymentMode: state.PaymentMode.loadingPaymentMode,
        errorPaymentMode: state.PaymentMode.errorPaymentMode,
    }); }), responsePaymentMode = _a.responsePaymentMode, loadingPaymentMode = _a.loadingPaymentMode, errorPaymentMode = _a.errorPaymentMode;
    useEffect(function () {
        if (trigger && projectId) {
            dispatch(paymentModeAction({ enable: true, page: 1, limit: 100, projectId: projectId }));
        }
    }, [trigger, projectId]);
    return {
        responsePaymentMode: responsePaymentMode,
        loadingPaymentMode: loadingPaymentMode,
        errorPaymentMode: errorPaymentMode,
    };
};
